import * as THREE from 'three';
import { EffectComposer } from 'three/addons/postprocessing/EffectComposer.js';
import { RenderPass } from 'three/addons/postprocessing/RenderPass.js';
import { UnrealBloomPass } from 'three/addons/postprocessing/UnrealBloomPass.js';
import { OutputPass } from 'three/addons/postprocessing/OutputPass.js';

export default class Effects {
  constructor(experience) {
    this.experience = experience;
    this.sizes = this.experience.sizes;
    this.scene = this.experience.scene;
    this.camera = this.experience.camera;
    this.renderer = this.experience.renderer;
    this.enabled = true;

    this.setComposer();
  }

  setComposer() {
    this.composer = new EffectComposer(this.renderer.instance);

    // 1. Render Pass
    const renderPass = new RenderPass(this.scene, this.camera.instance);
    this.composer.addPass(renderPass);

    // 2. Subtle Bloom Pass (calibrated to preserve crisp voxel edges)
    this.bloomPass = new UnrealBloomPass(
      new THREE.Vector2(this.sizes.width, this.sizes.height),
      0.2,   // strength
      0.25,  // radius
      0.90   // threshold
    );
    this.composer.addPass(this.bloomPass);

    // 3. Output Pass for correct sRGB gamma and tone mapping
    const outputPass = new OutputPass();
    this.composer.addPass(outputPass);
  }

  setTheme(isDark) {
    if (isDark) {
      this.bloomPass.strength = 0.22;
      this.bloomPass.threshold = 0.88;
    } else {
      // In light mode, virtually disable bloom to ensure 100% crisp, sharp voxel contours
      this.bloomPass.strength = 0.05;
      this.bloomPass.threshold = 0.98;
    }
  }

  resize() {
    this.composer.setSize(this.sizes.width, this.sizes.height);
    this.composer.setPixelRatio(this.sizes.pixelRatio);
    this.bloomPass.resolution.set(this.sizes.width, this.sizes.height);
  }

  update() {
    if (this.enabled) {
      this.composer.render();
    }
  }
}
